import React, { Component } from 'react';
import moment from 'moment';
import { Card, CardText, CardActions } from 'material-ui/Card';
import { Step, StepButton, StepContent, Stepper } from 'material-ui/Stepper';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import Subheader from 'material-ui/Subheader';
import Checkbox from 'material-ui/Checkbox';

import { formatMinutesAsTime } from 'utils/datetime';
import { isFeatureDisabled } from 'utils/auth';
import L from 'components/Loadable';
import AltitudeStep from './AltitudeStep';

const LoadableDateRangePicker = L(() =>
  import(/* webpackChunkName: 'hud' */
  'react-dates/lib/components/DateRangePicker')
);
const LoadableInputRange = L(() =>
  import(/* webpackChunkName: 'hud' */
  'react-input-range')
);

export default class HUDStepper extends Component {
  state = {
    startDate: null,
    endDate: null,
    dateFocusedInput: null,
  };

  dateValuesDirty = false;

  afterStateChange = () => {
    let { startDate, endDate } = this.state;

    if (!this.state.dateFocusedInput && this.dateValuesDirty) {
      this.dateValuesDirty = false;
      this.props.setDateRange({ min: startDate, max: endDate });
      this.setState({ startDate: null, endDate: null });
    }
  };

  handleDatesChange = ({ startDate, endDate }) => {
    this.dateValuesDirty =
      (startDate && !startDate.isSame(this.state.startDate)) ||
      (endDate && !endDate.isSame(this.state.endDate));

    this.setState({ startDate, endDate }, this.afterStateChange);
  };

  handleFocusChange = dateFocusedInput =>
    this.setState({ dateFocusedInput }, this.afterStateChange);

  isOutsideRange = (day) => {
    const start = isFeatureDisabled('date_range_past') ? moment().endOf('day') : moment('1970-01-01');
    const end = isFeatureDisabled('date_range_future') ? moment().endOf('day') : moment('9999-12-31');

    return (day.isBefore(start, 'day') || day.isAfter(end, 'day'));
  };

  render() {
    const {
      hud,
      browser,

      dateRange,
      timeRange,
      altitudeRange,
      airspaceUseType,
      isSRSS,

      hasSubscription,
      isInPast,

      setHUDStep,
      setAltitudeRange,

      resetDateRange,
      setTimeRange,
      setIsSRSS,

      setAirspaceUseType,

      toggleDrawMode,
      toggleHUD,

      styles,
    } = this.props;

    const transitionDuration = hud.hudTourInProgress ? 0 : 200;

    return (
      <React.Fragment>
        { /* isInPast && (
          <Card initiallyExpanded={true} style={styles.pastWarning}>
            <CardText expandable={true}>
              Múltbeli időpontra nincs lehetőség eseti légtér keresésére. Eseti
              légtér kereséséhez állítsa a dátumválasztót későbbi időpontra.
            </CardText>
            <CardActions>
              <FlatButton label="Vissza a jelenbe" onClick={resetDateRange} />
            </CardActions>
          </Card>
        ) */
        }
        <Stepper
          activeStep={hud.step}
          orientation="vertical"
          linear={false}
          style={styles.stepper}
        >
          <Step className="hud-tour__step-0">
            <StepButton onClick={() => setHUDStep(0)}>
              Válassza ki a légtérigénylés idejét
            </StepButton>
            <StepContent transitionDuration={transitionDuration}>
              <Subheader style={styles.subHeader}>Dátumtartomány</Subheader>
              <div style={styles.datePickerContainer}>
                <LoadableDateRangePicker
                  startDatePlaceholderText="Kezdődátum"
                  endDatePlaceholderText="Végdátum"
                  startDate={this.state.startDate || dateRange.min}
                  endDate={this.state.endDate || dateRange.max}
                  isOutsideRange={this.isOutsideRange}
/*                  isOutsideRange={hasSubscription ? () => false : undefined} */
                  onDatesChange={this.handleDatesChange}
                  displayFormat="YYYY. MMM DD."
                  renderMonth={m => m.format('YYYY. MMMM')}
                  focusedInput={this.state.dateFocusedInput}
                  onFocusChange={this.handleFocusChange}
                  withPortal={browser.greaterThan.small}
                  withFullScreenPortal={browser.lessThan.medium}
                  numberOfMonths={1}
                  firstDayOfWeek={1}
                  minimumNights={0}
                  hideKeyboardShortcutsPanel
                />
              </div>
              <Subheader style={styles.subHeader}>
                Napi érvényesség (UTC)
              </Subheader>
              <Checkbox
                label="Napkeltétől napnyugtáig"
                labelPosition="right"
                style={styles.checkbox}
                onCheck={(_, value) => {
                  setIsSRSS(value);
                }}
              />
              <div style={styles.inputRangeContainer}>
                <LoadableInputRange
                  minValue={0}
                  maxValue={1440}
                  step={15}
                  formatLabel={formatMinutesAsTime(true)}
                  value={timeRange}
                  onChange={setTimeRange}
                  disabled={isSRSS}
                />
              </div>
            </StepContent>
          </Step>
          <Step className="hud-tour__step-1" disabled={isFeatureDisabled('request_reason')}>
            <StepButton onClick={() => setHUDStep(1)}>
              Válassza ki az igénylés célját
            </StepButton>
            <StepContent transitionDuration={transitionDuration}>
              <RadioButtonGroup
                name="useType"
                valueSelected={airspaceUseType}
                style={styles.radioButtonGroup}
                onChange={(_, t) => setAirspaceUseType(t)}
              >
                <RadioButton
                  value="UAV_FLIGHT"
                  label="Repülés pilóta nélküli légijárművel"
                  style={styles.radioButton}
                />
                <RadioButton
                  value="MISC"
                  label="Egyéb cél"
                  style={styles.radioButton}
                />
              </RadioButtonGroup>
            </StepContent>
          </Step>
          <Step className="hud-tour__step-2" disabled={isFeatureDisabled('flight_altitude')}>
            <StepButton onClick={() => setHUDStep(2)}>
              Válassza ki a repülési magasságot (AMSL)
            </StepButton>
            <StepContent transitionDuration={transitionDuration}>
              <AltitudeStep
                altitudeRange={altitudeRange}
                setAltitudeRange={setAltitudeRange}
              />
            </StepContent>
          </Step>
          <Step className="hud-tour__step-3" disabled={isInPast}>
            <StepButton
              onClick={() => {
                toggleHUD(false);
                toggleDrawMode(true);
              }}
            >
              Jelölje ki a pontos területet
            </StepButton>
          </Step>
        </Stepper>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/HUD/HUDStepper.js